<template>
  <div class="analyse_item_tile">
    <div class="analyse_item_tile_before">
      <div class="analyse_item_tile_before_left"></div>
      <div class="analyse_item_tile_before_right"></div>
    </div>
    <div class="analyse_item_tile_text">
      {{node_name}}
    </div>
  </div>
</template>

<script>
export default {
  props:['node_name']
}
</script>

<style lang="less" scoped>
.analyse_item_tile{
  width: 100%;
  height: 46px;
  font-size: 14px;
  font-weight: bold;
  position: relative;
  margin-bottom: 20px;
  .analyse_item_tile_text{
    line-height: 46px;
    font-size: 14px;
    font-weight: bold;
    color: #0E0A31;
  }
  .analyse_item_tile_before{
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
    .analyse_item_tile_before_left{
      width: 24px;
      height: 2px;
      background: #1FBCBF;
    }
    .analyse_item_tile_before_right{
      width: 38px;
      height: 2px;
      background: #DCDCDC;
    }
  }
}
</style>